import { HttpResponse, instance } from '../../lib/axiosInstance'

/**
 * Builds a "GET resource by community plan id" action for a given base route.
 * Returns undefined if the request fails, matching the existing fetch helpers.
 */
export const createGetByIdAction =
  (baseRoute: string) =>
  async (communityPlanId: string): Promise<HttpResponse | undefined> => {
    try {
      return await instance.get(`${baseRoute}/${communityPlanId}`)
    } catch (e) {}
    return undefined
  }
